<div class="back-btn mb-3" (click)="back()">
  <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
  <span> {{ 'NAVIGATION_BACK' | translate }} </span>
</div>
